import React, { useState, useEffect, useMemo } from 'react'
import '../styles/Portfolio.css'
import qrcodeImage from '../assets/qrcode.png'
import reservationImage from '../assets/reservation.png'
import portfolioImage from '../assets/portfolio.png'
import stellastravelImage from '../assets/stellastravel.png'
import { useTranslation } from '../context/LanguageContext.jsx'

const STATIC_BY_INDEX = [
  {
    id: 1,
    image: reservationImage,
    technologies: ['React', 'Node.js', 'MongoDB', 'Socket.io'],
    link: 'https://deverse.cc',
  },
  {
    id: 2,
    image: qrcodeImage,
    technologies: ['React', 'QR Code API', 'CSS3', 'JavaScript'],
    link: 'https://portofino-eight.vercel.app/menu/',
  },
  {
    id: 3,
    image: portfolioImage,
    technologies: ['React', 'CSS3', 'JavaScript', 'Vite'],
    link: 'https://stylianos1995.github.io/stylianos/',
  },
  {
    id: 4,
    image: stellastravelImage,
    technologies: ['React', 'CSS3', 'JavaScript', 'i18n'],
    link: 'https://www.stellastravel.com',
  },
]

const Portfolio = () => {
  const { t, dict } = useTranslation()

  const projects = useMemo(() => {
    const bases = dict.portfolio.projects
    return bases.map((p, i) => ({ ...p, ...STATIC_BY_INDEX[i] }))
  }, [dict.portfolio.projects])

  const [currentIndex, setCurrentIndex] = useState(0)
  const [slideDirection, setSlideDirection] = useState('right')
  const [userInteracted, setUserInteracted] = useState(false)

  useEffect(() => {
    if (userInteracted) return

    const interval = setInterval(() => {
      setSlideDirection('right')
      setCurrentIndex((prevIndex) => (prevIndex + 1) % projects.length)
    }, 15000)

    return () => clearInterval(interval)
  }, [projects.length, userInteracted])

  const nextProject = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setUserInteracted(true)
    setSlideDirection('right')
    setCurrentIndex((prevIndex) => (prevIndex + 1) % projects.length)
  }

  const prevProject = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setUserInteracted(true)
    setSlideDirection('left')
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? projects.length - 1 : prevIndex - 1))
  }

  const goToProject = (index, e) => {
    e.preventDefault()
    e.stopPropagation()
    setUserInteracted(true)
    const direction = index > currentIndex ? 'right' : 'left'
    setSlideDirection(direction)
    setCurrentIndex(index)
  }

  const currentProject = projects[currentIndex]
  const linkLabel = currentProject.linkLabel || t('portfolio.viewProject')
  const featuresLabel = currentProject.featuresLabel || t('portfolio.keyFeatures')

  return (
    <section id="portfolio" className="portfolio">
      <h2>{t('portfolio.title')}</h2>

      <div className="project-container">
        <div className={`project-card slide-${slideDirection}`}>
          <div className="project-info">
            <div className="project-header">
              {currentProject.badge && (
                <span className="project-badge">{currentProject.badge}</span>
              )}
              <h3>{currentProject.title}</h3>
              <p className="project-description">{currentProject.description}</p>
            </div>

            <div className="project-features">
              <h4>{featuresLabel}</h4>
              <ul>
                {currentProject.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>

            <div className="project-footer">
              <div className="project-technologies">
                {currentProject.technologies.map((tech, index) => (
                  <span key={index} className="tech-tag">
                    {tech}
                  </span>
                ))}
              </div>
              <a
                href={currentProject.link}
                className="project-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                {linkLabel}
              </a>
            </div>
          </div>
          <div className="project-image">
            <img src={currentProject.image} alt={currentProject.title} />
          </div>

          <button className="carousel-nav prev" onClick={prevProject} type="button">
            <span>‹</span>
          </button>
          <button className="carousel-nav next" onClick={nextProject} type="button">
            <span>›</span>
          </button>

          <div className="carousel-dots">
            {projects.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentIndex ? 'active' : ''}`}
                onClick={(e) => goToProject(index, e)}
                type="button"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Portfolio
